
import Tooltip from '../index';
import IconButton from '../../icon-button';
import HintTooltipProps from '../mixins/HintTooltipProps';
import { TooltipSlotName, HintTooltipProperty, TooltipDisplayType } from '../enum';
import { IconType, IconProperty } from '../../icon/enums';
import { StyleColorSchemeType, StyleSizeType } from '../../../styles/enums';
import StyleClassNamesBuilder from '../../../styles/helpers/StyleClassNamesBuilder';

export default {
  name: 'HintTooltip',
  components: {
    Tooltip,
    IconButton,
  },
  mixins: [HintTooltipProps],
  data() {
    return {
      IconType,
      IconProperty,
      StyleColorSchemeType,
      StyleSizeType,
      TooltipSlotName,
      HintTooltipProperty,
    };
  },
  computed: {
    closeButtonColorScheme() {
      return this[HintTooltipProperty.ColorScheme] === StyleColorSchemeType.White
        ? StyleColorSchemeType.Gray
        : StyleColorSchemeType.White;
    },
    hintClasses() {
      return new StyleClassNamesBuilder('hint-content')
        .addConditionClassNames(
          Object.values(StyleColorSchemeType),
          this[HintTooltipProperty.ColorScheme],
        ).build();
    },
    isTemporaryDisplayType() {
      return this[HintTooltipProperty.DisplayType] === TooltipDisplayType.Temporary;
    },
  },
};
